


export const configurations = {
	'terminal1': {
		title: 'Hauptstraße (Terminal 1)',
		hostName: 'terminal.hellers24.de',
		apiUrl: 'https://backend.hellers24.de/api/',
		texts: {
			keyboy: 'checkin.welcome.keyboy',
			infoKey: 'checkin.welcome.info',
			allRoomsFull: 'checkin.roomCategory.allRoomsFull',
		},
		bookingRoomCategoryCodes: [
			{
				//override: true,
				//price: 156.90,
				roomTitle: 'checkin.roomCategory.text.singleRoom.title',
				description: 'checkin.roomCategory.text.singleRoom.description',
				addDescription: 'checkin.roomCategory.text.singleRoom.addDescription',
				roomInfo: 'checkin.roomCategory.text.singleRoom.roomInfo',

				code: 'TER1',
				overrideCode: 'TER1',
				images: ['/assets/images/roomscategories/01-Zimmer.jpg']
			},
			{
				//override: true,
				//price: 230.00,
				roomTitle: 'checkin.roomCategory.text.doubleRoom.title',
				description: 'checkin.roomCategory.text.doubleRoom.description',
				addDescription: 'checkin.roomCategory.text.doubleRoom.addDescription',
				roomInfo: 'checkin.roomCategory.text.doubleRoom.roomInfo',

				code: 'TER2',
				overrideCode: 'TER2', // WAR TER1!! Hier alles trotzdem auf TER1 buchen!!
				images: ['/assets/images/roomscategories/02-Zimmer.jpg']
			}
		],
	},
	'terminal2': {
		title: 'Sonnenbergstraße (Terminal 2)',
		hostName: 'terminal2.hellers24.de',
		apiUrl: 'https://backend2.hellers24.de/api/',
		texts: {
			keyboy: 'checkin.welcome.keyboyLeft',
			infoKey: 'checkin.welcome.infoKeyEntrance',
			allRoomsFull: 'checkin.roomCategory.allRoomsFullTwo',
		},
		bookingRoomCategoryCodes: [
			{
				//override: true,
				//price: 156.90,
				roomTitle: 'checkin.roomCategory.text.singleRoom.title',
				description: 'checkin.roomCategory.text.singleRoom.description',
				addDescription: 'checkin.roomCategory.text.singleRoom.addDescription',
				roomInfo: 'checkin.roomCategory.text.singleRoom.roomInfo',

				code: 'TER1',
				overrideCode: 'TER1',
				images: [
					'/assets/images/roomscategories/ez-sonnenberg-01.jpg',
					'/assets/images/roomscategories/ez-sonnenberg-02.jpg'
				]
			},
			{
				//override: true,
				//price: 230.00,
				roomTitle: 'checkin.roomCategory.text.doubleRoom.title',
				description: 'checkin.roomCategory.text.doubleRoom.description',
				addDescription: 'checkin.roomCategory.text.doubleRoom.addDescription',
				roomInfo: 'checkin.roomCategory.text.doubleRoom.roomInfo',

				code: 'TER2',
				overrideCode: 'TER2',
				images: [
					'/assets/images/roomscategories/dz-sonnenberg-01.jpg',
					'/assets/images/roomscategories/dz-sonnenberg-02.jpg'
				]
			}
		],
	}
};

// if on local machine: Add option for staging-server

if (window.location.hostname == 'localhost') {
	configurations.staging = Object.assign({}, configurations.terminal2, {
		title: 'DEV-System',
		hostName: 'staging.hellers24.de',
		apiUrl: 'https://staging-backend.hellers24.de/api/',
		bookingRoomCategoryCodes: [
			{
				//override: true,
				//price: 156.90,
				roomTitle: 'checkin.roomCategory.text.singleRoom.title',
				description: 'checkin.roomCategory.text.singleRoom.description',
				addDescription: 'checkin.roomCategory.text.singleRoom.addDescription',
				roomInfo: 'checkin.roomCategory.text.singleRoom.roomInfo',

				code: 'TER1',
				overrideCode: 'TER1',
				images: ['/assets/images/roomscategories/01-Zimmer.jpg']
			},
			{
				//override: true,
				//price: 230.00,
				roomTitle: 'checkin.roomCategory.text.doubleRoom.title',
				description: 'checkin.roomCategory.text.doubleRoom.description',
				addDescription: 'checkin.roomCategory.text.doubleRoom.addDescription',
				roomInfo: 'checkin.roomCategory.text.doubleRoom.roomInfo',

				code: 'TER2',
				overrideCode: 'TER1', // Hier alles trotzdem auf TER1 buchen!!
				images: ['/assets/images/roomscategories/02-Zimmer.jpg']
			}
		]
	});
}